import classNames from "classnames";
import React from "react";
import styles from "../statics/styles/audio.rtlignore-scss.js";
const Duration = ({ seconds }) => {
  return /* @__PURE__ */ React.createElement("time", { dateTime: `P${Math.round(seconds)}S` }, format(seconds));
};
function format(seconds) {
  const date = new Date(seconds * 1e3);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`;
  }
  return `${mm}:${ss}`;
}
function pad(string) {
  return ("0" + string).slice(-2);
}
const AudioDuration = ({ played, duration, isLoading }) => {
  return /* @__PURE__ */ React.createElement("div", { className: classNames(styles.audioDuration, { [styles.isLoading]: isLoading }) }, isLoading ? "--:--" : /* @__PURE__ */ React.createElement(Duration, { seconds: played > 0 ? played * duration : duration }));
};
var AudioDuration_default = AudioDuration;
export {
  AudioDuration_default as default
};
//# sourceMappingURL=AudioDuration.js.map
